<template>
  <div>
    <vue-tabs v-if="store" class="card-content">
      <v-tab title="Tableau de bord">
        <Dashboard :store="store" />
      </v-tab>
      <v-tab title="Actualités">
        <Timeline :store="store" />
      </v-tab>
      <v-tab title="Messages">
        <Messages :store="store" />
      </v-tab>
      <v-tab title="Paramètres">
        <Settings :store="store" />
      </v-tab>
    </vue-tabs>
    <div v-else>
      <div class="card card-lock">
        <h4>Chargement...</h4>
      </div>
    </div>
  </div>
</template>
<script>
  import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
  import Dashboard from '@/components/Store/Dashboard'
  import Messages from '@/components/Store/Messages'
  import Timeline from '@/components/Store/Timeline'
  import Settings from '@/components/Store/Settings'

  import { mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      Messages,
      Dashboard,
      Timeline,
      Settings
    },
    computed: {
      ...mapGetters('stores', [
        'find'
      ]),
      store () {
        return this.find(this.$route.params.store)
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/Company/Store/View.vue